<template>
  <button class="action-button" v-on="$listeners">
    <slot></slot>
  </button>
</template>

<script>
export default {};
</script>

<style scoped>
.action-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: 6px 4px;

  &:hover {
    background-color: #D4D4D8;
    border-radius: 6px;
  }
}
</style>
